function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SOL_svg__a",
  gradientUnits: "userSpaceOnUse",
  x1: 360.879,
  y1: 351.455,
  x2: 141.213,
  y2: -69.294,
  gradientTransform: "matrix(1 0 0 -1 0 314)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00ffa3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#dc1fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M64.6 237.9c2.4-2.4 5.7-3.8 9.2-3.8h317.4c5.8 0 8.7 7 4.6 11.1l-62.7 62.7c-2.4 2.4-5.7 3.8-9.2 3.8H6.5c-5.8 0-8.7-7-4.6-11.1l62.7-62.7z",
  fill: "url(#SOL_svg__a)"
});

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SOL_svg__b",
  gradientUnits: "userSpaceOnUse",
  x1: 264.829,
  y1: 401.601,
  x2: 45.163,
  y2: -19.148,
  gradientTransform: "matrix(1 0 0 -1 0 314)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00ffa3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#dc1fff"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M64.6 3.8C67.1 1.4 70.4 0 73.8 0h317.4c5.8 0 8.7 7 4.6 11.1l-62.7 62.7c-2.4 2.4-5.7 3.8-9.2 3.8H6.5c-5.8 0-8.7-7-4.6-11.1L64.6 3.8z",
  fill: "url(#SOL_svg__b)"
});

var _ref5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SOL_svg__c",
  gradientUnits: "userSpaceOnUse",
  x1: 312.548,
  y1: 376.688,
  x2: 92.882,
  y2: -44.061,
  gradientTransform: "matrix(1 0 0 -1 0 314)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00ffa3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#dc1fff"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M333.1 120.1c-2.4-2.4-5.7-3.8-9.2-3.8H6.5c-5.8 0-8.7 7-4.6 11.1l62.7 62.7c2.4 2.4 5.7 3.8 9.2 3.8h317.4c5.8 0 8.7-7 4.6-11.1l-62.7-62.7z",
  fill: "url(#SOL_svg__c)"
});

function SvgSol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 397.7 311.7"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default __webpack_public_path__ + "ae6adb367483bbfe56aa6e2e5641ddc0.svg";
export { SvgSol as ReactComponent };